export default __webpack_public_path__ + "static/media/img--design-7.174360a4.jpg";